/* ═══════════════════════════════════════════════════════════════
   Apilink Theme Editor
   Extracted from _theme_custom.html.erb inline scripts.
   All public functions are exported to window.* for onclick/oninput HTML handlers.
   ═══════════════════════════════════════════════════════════════ */

/* ── 1. Global Palette Target System + Color Popover ── */

var _paletteTarget = {};
// Le popover maison ne sert plus qu'aux couleurs du premier plan (le panneau) : les autres
// couleurs passent par Ui::ColorPickerComponent (popover).
var _paletteUpdateFns = {
  'panel': function() { panelSyncPills(); updatePanelAnchors(); updatePanelPreview(); _panelSubmit(); },
};

var _cpCurrentGroup = null;
var _cpCurrentFieldId = null;
var _cpCurrentPill = null;

function _hexToRgba(hex, opacPct) {
  if (opacPct >= 100 || !hex || hex.charAt(0) !== '#' || hex.length !== 7) return hex;
  var r = parseInt(hex.substr(1, 2), 16);
  var g = parseInt(hex.substr(3, 2), 16);
  var b = parseInt(hex.substr(5, 2), 16);
  return 'rgba(' + r + ',' + g + ',' + b + ',' + (opacPct / 100).toFixed(2) + ')';
}

function _cpOpen(group, fieldId, triggerEl) {
  _cpCurrentGroup = group;
  _cpCurrentFieldId = fieldId;
  _cpCurrentPill = triggerEl;

  var popover = document.getElementById('color-popover');
  var field = document.getElementById(fieldId);
  var currentColor = field ? field.value : '#000000';

  document.getElementById('cp-swatch').style.background = currentColor;
  document.getElementById('cp-hex-input').value = currentColor;
  document.getElementById('cp-native-input').value = currentColor;

  var rect = triggerEl.getBoundingClientRect();
  popover.style.position = 'fixed';
  popover.style.left = Math.min(rect.left, window.innerWidth - 220) + 'px';

  var spaceBelow = window.innerHeight - rect.bottom;
  if (spaceBelow > 200) {
    popover.style.top = (rect.bottom + 4) + 'px';
    popover.style.bottom = 'auto';
  } else {
    popover.style.bottom = (window.innerHeight - rect.top + 4) + 'px';
    popover.style.top = 'auto';
  }

  popover.classList.add('open');

  setTimeout(function() {
    document.addEventListener('click', _cpOutsideClick);
  }, 10);
}

function _cpClose() {
  var popover = document.getElementById('color-popover');
  if (popover) popover.classList.remove('open');
  document.removeEventListener('click', _cpOutsideClick);
  _cpCurrentGroup = null;
  _cpCurrentFieldId = null;
  _cpCurrentPill = null;
}

function _cpOutsideClick(e) {
  var popover = document.getElementById('color-popover');
  if (popover && !popover.contains(e.target) && (!_cpCurrentPill || !_cpCurrentPill.contains(e.target))) {
    _cpClose();
  }
}

function _cpApplyColor(hex) {
  if (!_cpCurrentFieldId) return;
  var field = document.getElementById(_cpCurrentFieldId);
  if (!field) return;
  field.value = hex;

  document.getElementById('cp-swatch').style.background = hex;
  document.getElementById('cp-hex-input').value = hex;

  var fn = _paletteUpdateFns[_cpCurrentGroup];
  if (fn) fn();
  if (_cpCurrentGroup !== 'panel') field.form.requestSubmit();
}

function _cpPickColor(hex) {
  _cpApplyColor(hex);
}

function _cpNativeChanged(hex) {
  _cpApplyColor(hex);
}

function _cpHexCommit() {
  var input = document.getElementById('cp-hex-input');
  var val = input.value.trim();
  if (val && !val.startsWith('#')) val = '#' + val;
  if (/^#[0-9a-fA-F]{6}$/.test(val)) {
    _cpApplyColor(val);
  }
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') _cpClose();
});

/* ── 2. Images Preview ── */

function updateImagesPreview() {
  var logoH = parseInt(document.getElementById('theme_banner_height_field').value);
  var photoS = parseInt(document.getElementById('theme_photo_size_field').value);
  var photoR = parseInt(document.getElementById('theme_photo_radius_field').value);
  var gap = parseInt(document.getElementById('theme_logo_photo_gap_field').value);

  var ll = document.getElementById('img-logo-label');
  var pl = document.getElementById('img-photo-label');
  var rl = document.getElementById('photo-radius-label');
  var gl = document.getElementById('img-gap-label');
  if (ll) ll.textContent = logoH + 'px';
  if (pl) pl.textContent = photoS + 'px';
  if (rl) rl.textContent = photoR >= 50 ? '○' : photoR + '%';
  if (gl) gl.textContent = gap + 'px';

  var logoPreview = document.getElementById('img-preview-logo');
  var photoPreview = document.getElementById('img-preview-photo');
  var gapPreview = document.getElementById('img-preview-gap');
  if (logoPreview) logoPreview.style.height = Math.max(logoH * 0.4, 16) + 'px';
  if (gapPreview) {
    var scaledGap = Math.round(gap * 0.35);
    if (scaledGap >= 0) {
      gapPreview.style.height = scaledGap + 'px';
      gapPreview.style.marginTop = '0';
    } else {
      gapPreview.style.height = '0';
      gapPreview.style.marginTop = scaledGap + 'px';
    }
  }
  if (photoPreview) {
    var sz = Math.max(photoS * 0.3, 24);
    photoPreview.style.width = sz + 'px';
    photoPreview.style.height = sz + 'px';
    photoPreview.style.borderRadius = photoR >= 50 ? '9999px' : Math.round(photoR * sz / 100) + 'px';
  }
}

/* ── 3. Panel (Foreground) ── */

var _panelAnchorPos = {
  'bottom': {from:[50,0],to:[50,100]}, 'top': {from:[50,100],to:[50,0]},
  'right': {from:[0,50],to:[100,50]}, 'left': {from:[100,50],to:[0,50]},
  'bottom-right': {from:[0,0],to:[100,100]}, 'top-right': {from:[0,100],to:[100,0]},
  'bottom-left': {from:[100,0],to:[0,100]}, 'top-left': {from:[100,100],to:[0,0]},
  'radial': {from:[50,50],to:[90,90]}
};
var _panelCssDir = {
  'bottom':'to bottom','top':'to top','right':'to right','left':'to left',
  'bottom-right':'to bottom right','bottom-left':'to bottom left',
  'top-right':'to top right','top-left':'to top left','radial':'radial'
};

var _panelTextures = {
  'none': '',
  'noise': "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
  'grain': "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.6' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23g)'/%3E%3C/svg%3E\")",
  'dots': "url(\"data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='6' cy='6' r='1.5' fill='%23000' fill-opacity='0.3'/%3E%3C/svg%3E\")",
  'lines': "url(\"data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 8L8 0' stroke='%23000' stroke-opacity='0.2' stroke-width='1'/%3E%3C/svg%3E\")",
  'cross': "url(\"data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 0v12M0 6h12' stroke='%23000' stroke-opacity='0.15' stroke-width='0.8'/%3E%3C/svg%3E\")"
};

// Read initial panel color count from data attribute (set by ERB)
var _panelColorCount = 1;

function _panelGetDir() {
  return document.getElementById('panel_gradient_direction_field').value || 'bottom';
}
function _panelSubmit() {
  var f = document.getElementById('theme_panel_background_field');
  if (f && f.form) f.form.requestSubmit();
}
function _f(id) { return document.getElementById(id); }
var _pFields = function() {
  return {
    solid: _f('theme_panel_background_color_field'),
    from:  _f('theme_panel_gradient_from_field'),
    mid:   _f('theme_panel_gradient_mid_field'),
    to:    _f('theme_panel_gradient_to_field')
  };
};

function _panelGetColors() {
  var f = _pFields();
  if (_panelColorCount === 1) return [f.solid.value];
  if (_panelColorCount === 2) return [f.from.value, f.to.value];
  return [f.from.value, f.mid.value, f.to.value];
}

var _panelActivePill = 0;
function panelClickPill(index, event) {
  if (event) event.stopPropagation();
  _panelActivePill = index;
  var f = _pFields();
  [1,2,3].forEach(function(i) {
    var lbl = document.getElementById('panel-pill-label-' + i);
    if (lbl) lbl.classList.toggle('palette-active', (i-1) === index);
  });
  var fieldId, triggerEl;
  triggerEl = document.getElementById('panel-pill-label-' + (index + 1));
  if (_panelColorCount === 1) { fieldId = f.solid.id; }
  else if (_panelColorCount === 2) { fieldId = [f.from, f.to][index].id; }
  else { fieldId = [f.from, f.mid, f.to][index].id; }
  _paletteTarget['panel'] = fieldId;
  _cpOpen('panel', fieldId, triggerEl);
}

function panelSyncPills() {
  var colors = _panelGetColors();
  for (var i = 0; i < 3; i++) {
    var dot = document.getElementById('panel-dot-' + (i+1));
    var hex = document.getElementById('panel-hex-' + (i+1));
    if (dot && colors[i]) { dot.style.background = colors[i]; }
    if (hex && colors[i]) { hex.textContent = colors[i]; }
  }
}

function panelColorChanged() {
  panelSyncPills(); updatePanelAnchors(); updatePanelPreview();
}

function panelSwapColors(a, b) {
  var f = _pFields();
  var fields;
  if (_panelColorCount === 2) fields = [f.from, f.to];
  else if (_panelColorCount === 3) fields = [f.from, f.mid, f.to];
  else return;
  if (!fields[a] || !fields[b]) return;
  var tmp = fields[a].value; fields[a].value = fields[b].value; fields[b].value = tmp;
  panelSyncPills(); updatePanelAnchors(); updatePanelPreview(); _panelSubmit();
}

function panelAddColor() {
  if (_panelColorCount >= 3) return;
  var f = _pFields();
  _panelColorCount++;

  if (_panelColorCount === 2) {
    f.from.setAttribute('type', 'color'); f.from.value = f.solid.value;
    f.to.setAttribute('type', 'color');
    if (!f.to.value || f.to.value === '#000000') f.to.value = '#e2e8f0';
    document.getElementById('panel-pill-2-wrap').classList.remove('hidden');
    document.getElementById('panel-direction-wrap').classList.remove('hidden');
    showPanelAnchors(true);
  } else if (_panelColorCount === 3) {
    f.mid.setAttribute('type', 'color'); f.mid.value = '#888888';
    document.getElementById('panel-pill-3-wrap').classList.remove('hidden');
    document.getElementById('panel-anchor-mid').classList.remove('hidden');
  }

  document.getElementById('panel-add-color-btn').classList.toggle('hidden', _panelColorCount >= 3);
  document.getElementById('panel-remove-color-btn').classList.remove('hidden');
  panelSyncPills(); updatePanelAnchors(); updatePanelPreview(); _panelSubmit();
}

function panelRemoveColor() {
  if (_panelColorCount <= 1) return;
  var f = _pFields();

  if (_panelColorCount === 3) {
    f.mid.setAttribute('type', 'hidden');
    f.mid.value = '';
    document.getElementById('panel-pill-3-wrap').classList.add('hidden');
    document.getElementById('panel-anchor-mid').classList.add('hidden');
  } else if (_panelColorCount === 2) {
    f.solid.value = f.from.value;
    f.from.setAttribute('type', 'hidden'); f.from.value = '';
    f.to.setAttribute('type', 'hidden');   f.to.value = '';
    document.getElementById('panel-pill-2-wrap').classList.add('hidden');
    document.getElementById('panel-direction-wrap').classList.add('hidden');
    showPanelAnchors(false);
  }

  _panelColorCount--;
  document.getElementById('panel-add-color-btn').classList.remove('hidden');
  document.getElementById('panel-remove-color-btn').classList.toggle('hidden', _panelColorCount <= 1);
  panelSyncPills(); updatePanelAnchors(); updatePanelPreview(); _panelSubmit();
}

function showPanelAnchors(show) {
  ['panel-anchor-from','panel-anchor-to','panel-anchor-line'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) { if (show) el.classList.remove('hidden'); else el.classList.add('hidden'); }
  });
  var solid = document.getElementById('panel-anchor-solid');
  if (solid) { if (show) solid.classList.add('hidden'); else solid.classList.remove('hidden'); }
  if (!show) document.getElementById('panel-anchor-mid').classList.add('hidden');
}

function setPanelGradientDir(dir) {
  document.getElementById('panel_gradient_direction_field').value = dir;
  document.querySelectorAll('.panel-dir-btn').forEach(function(btn) {
    btn.className = 'panel-dir-btn w-7 h-7 flex items-center justify-center text-[10px] transition-all ' +
      (btn.dataset.dir === dir ? 'bg-indigo-500 text-white' : 'bg-white text-gray-500 hover:bg-gray-50');
  });
  updatePanelAnchors(); updatePanelPreview(); _panelSubmit();
}

function setPanelTexture(tex) {
  document.getElementById('panel_texture_field').value = tex;
  document.querySelectorAll('.panel-texture-btn').forEach(function(btn) {
    btn.className = 'panel-texture-btn px-1.5 py-0.5 text-[9px] rounded transition-all ' +
      (btn.dataset.texture === tex ? 'bg-indigo-500 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200');
  });
  document.getElementById('panel-texture-slider-wrap').classList.toggle('hidden', tex === 'none');
  updatePanelTextureOverlay(tex);
  _panelSubmit();
}

function updateTextureIntensity() {
  var val = parseInt(document.getElementById('theme_panel_texture_intensity_field').value);
  var overlay = document.getElementById('panel-texture-overlay');
  if (overlay) overlay.style.opacity = (val / 100).toFixed(2);
  var label = document.getElementById('panel-texture-label');
  if (label) label.textContent = val + '%';
}

function updateTextureSize() {
  var val = parseInt(document.getElementById('theme_panel_texture_size_field').value);
  var label = document.getElementById('panel-texture-size-label');
  if (label) label.textContent = val + '%';
  var overlay = document.getElementById('panel-texture-overlay');
  if (overlay) {
    var texField = document.getElementById('panel_texture_field');
    var tex = texField ? texField.value : 'none';
    _applyTextureSize(overlay, tex, val);
  }
}

function _applyTextureSize(overlay, tex, sizePct) {
  if (tex === 'noise' || tex === 'grain') {
    var px = Math.round(200 * sizePct / 100);
    overlay.style.backgroundSize = px + 'px ' + px + 'px';
  } else if (tex !== 'none') {
    var px2 = Math.round(12 * sizePct / 100);
    overlay.style.backgroundSize = Math.max(px2, 3) + 'px ' + Math.max(px2, 3) + 'px';
  }
}

function updatePanelTextureOverlay(tex) {
  var overlay = document.getElementById('panel-texture-overlay');
  if (!overlay) return;
  var bg = _panelTextures[tex] || '';
  overlay.style.backgroundImage = bg;
  var sizeField = document.getElementById('theme_panel_texture_size_field');
  var sizePct = sizeField ? parseInt(sizeField.value) : 100;
  _applyTextureSize(overlay, tex, sizePct);
}

function updatePanelAnchors() {
  var dir = _panelGetDir();
  var pos = _panelAnchorPos[dir] || _panelAnchorPos['bottom'];
  var anchorFrom = document.getElementById('panel-anchor-from');
  var anchorMid = document.getElementById('panel-anchor-mid');
  var anchorTo = document.getElementById('panel-anchor-to');
  var line = document.getElementById('panel-anchor-line-el');
  var solid = document.getElementById('panel-anchor-solid');

  if (_panelColorCount >= 2) {
    var colors = _panelGetColors();
    if (anchorFrom) { anchorFrom.style.left = pos.from[0]+'%'; anchorFrom.style.top = pos.from[1]+'%'; anchorFrom.style.background = colors[0]; }
    if (anchorTo) { anchorTo.style.left = pos.to[0]+'%'; anchorTo.style.top = pos.to[1]+'%'; anchorTo.style.background = colors[colors.length-1]; }
    if (anchorMid && _panelColorCount === 3) {
      anchorMid.style.left = ((pos.from[0]+pos.to[0])/2)+'%';
      anchorMid.style.top = ((pos.from[1]+pos.to[1])/2)+'%';
      anchorMid.style.background = colors[1];
    }
    if (line) { line.setAttribute('x1',pos.from[0]+'%'); line.setAttribute('y1',pos.from[1]+'%'); line.setAttribute('x2',pos.to[0]+'%'); line.setAttribute('y2',pos.to[1]+'%'); }
    var toLabel = anchorTo ? anchorTo.querySelector('.panel-anchor-label') : null;
    if (toLabel) toLabel.textContent = _panelColorCount === 3 ? '3' : '2';
  } else {
    var solidColor = document.getElementById('theme_panel_background_color_field').value;
    if (solid) solid.style.background = solidColor;
  }
}

function updatePanelPreview() {
  var opacity = parseInt(document.getElementById('theme_panel_background_field').value);
  var blur = parseInt(document.getElementById('theme_panel_blur_field').value);
  var preview = document.getElementById('panel-opacity-preview');
  if (_panelColorCount >= 2) {
    var colors = _panelGetColors();
    var stops = colors.map(function(c) { return _hexToRgba(c, opacity); });
    var dir = _panelGetDir();
    if (dir === 'radial') {
      preview.style.background = 'radial-gradient(circle, ' + stops.join(', ') + ')';
    } else {
      preview.style.background = 'linear-gradient(' + (_panelCssDir[dir]||'to bottom') + ', ' + stops.join(', ') + ')';
    }
  } else {
    var hex = document.getElementById('theme_panel_background_color_field').value;
    preview.style.background = _hexToRgba(hex, opacity);
    updatePanelAnchors();
  }

  preview.style.backdropFilter = blur > 0 ? 'blur('+blur+'px)' : 'none';
  preview.style.webkitBackdropFilter = blur > 0 ? 'blur('+blur+'px)' : 'none';
  var ol = document.getElementById('panel-opacity-label');
  var bl = document.getElementById('panel-blur-label');
  if (ol) ol.textContent = opacity + '%';
  if (bl) bl.textContent = blur + 'px';
}

function updatePanelBorderRadius() {
  var field = document.getElementById('theme_panel_border_radius_field');
  if (!field) return;
  var val = parseInt(field.value);
  var container = document.getElementById('panel-preview-container');
  if (container) container.style.borderRadius = Math.round(val * 0.15) + 'px';
  var label = document.getElementById('panel-radius-label');
  if (label) label.textContent = val + 'px';
}

/* ── 4. Text / Font ── */

function updateNamePreview() {
  var preview = document.getElementById('name-style-preview');
  if (!preview) return;
  var fontSel = document.getElementById('theme_name_font_family_field');
  var sizeSl = document.getElementById('theme_name_size_field');
  var boldF = document.getElementById('name_bold_field');
  var italicF = document.getElementById('name_italic_field');
  var sizeLabel = document.getElementById('name-size-label');

  if (fontSel.value) {
    preview.style.fontFamily = "'" + fontSel.value + "', sans-serif";
  } else {
    var mainFont = document.getElementById('theme_font_family_field');
    preview.style.fontFamily = mainFont ? "'" + mainFont.value + "', sans-serif" : '';
  }
  preview.style.fontSize = sizeSl.value + 'px';
  preview.style.fontWeight = boldF.value === 'true' ? 'bold' : 'normal';
  preview.style.fontStyle = italicF.value === 'true' ? 'italic' : 'normal';
  if (sizeLabel) sizeLabel.textContent = sizeSl.value;
}

function toggleNameBold() {
  var f = document.getElementById('name_bold_field');
  var btn = document.getElementById('name-bold-btn');
  var isOn = f.value === 'true';
  f.value = isOn ? 'false' : 'true';
  btn.className = 'w-8 h-8 rounded-md flex items-center justify-center text-sm font-bold transition-all ' + (isOn ? 'bg-gray-100 text-gray-500 hover:bg-gray-200' : 'bg-indigo-500 text-white');
  updateNamePreview();
  f.form.requestSubmit();
}

function toggleNameItalic() {
  var f = document.getElementById('name_italic_field');
  var btn = document.getElementById('name-italic-btn');
  var isOn = f.value === 'true';
  f.value = isOn ? 'false' : 'true';
  btn.className = 'w-8 h-8 rounded-md flex items-center justify-center text-sm italic transition-all ' + (isOn ? 'bg-gray-100 text-gray-500 hover:bg-gray-200' : 'bg-indigo-500 text-white');
  updateNamePreview();
  f.form.requestSubmit();
}

function textColorChanged() {
  var input = document.getElementById('theme_color_field');
  var dot = document.getElementById('text-color-dot');
  var hex = document.getElementById('text-color-hex');
  var preview = document.getElementById('name-style-preview');
  if (dot) dot.style.background = input.value;
  if (hex) hex.textContent = input.value;
  if (preview) preview.style.color = input.value;
}

/* ── 5. Contact Buttons ── */

function updateContactPreview() {
  var bg = document.getElementById('contact_link_background_field').value;
  var color = document.getElementById('contact_link_color_field').value;
  var r = parseInt(document.getElementById('contact_link_rounded_field').value);
  var s = parseInt(document.getElementById('contact_link_shadow_field').value);
  var blur = parseInt(document.getElementById('contact_link_blur_field').value);
  var opac = parseInt(document.getElementById('contact_link_opacity_field').value);
  var bgDot = document.getElementById('contact-bg-dot');
  var bgHex = document.getElementById('contact-bg-hex');
  var textDot = document.getElementById('contact-text-dot');
  var textHex = document.getElementById('contact-text-hex');
  if (bgDot) bgDot.style.background = bg;
  if (bgHex) bgHex.textContent = bg;
  if (textDot) textDot.style.background = color;
  if (textHex) textHex.textContent = color;
  var radius = r >= 24 ? '9999px' : r + 'px';
  var shadow = 'none';
  if (s > 0) {
    var y = (s * 0.4).toFixed(1);
    var opacity = (0.04 + s * 0.018).toFixed(3);
    shadow = '0 ' + y + 'px ' + s + 'px rgba(0,0,0,' + opacity + ')';
  }
  var bgRgba = _hexToRgba(bg, opac);
  var bdFilter = blur > 0 ? 'blur(' + blur + 'px)' : 'none';
  ['contact-preview-phone', 'contact-preview-email'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) {
      el.style.backgroundColor = bgRgba;
      el.style.borderRadius = radius;
      el.style.boxShadow = shadow;
      el.style.backdropFilter = bdFilter;
      el.style.webkitBackdropFilter = bdFilter;
      el.querySelectorAll('span, svg').forEach(function(child) { child.style.color = color; });
    }
  });
  var rl = document.getElementById('contact-rounded-label');
  if (rl) rl.textContent = r >= 24 ? '∞' : r + 'px';
  var sl = document.getElementById('contact-shadow-label');
  if (sl) sl.textContent = s;
  var bl = document.getElementById('contact-blur-label');
  if (bl) bl.textContent = blur + 'px';
  var ol = document.getElementById('contact-opacity-label');
  if (ol) ol.textContent = opac + '%';
}

/* ── 6. Link Buttons ── */

function updateBtnPreview() {
  var preview = document.getElementById('btn-style-preview');
  if (!preview) return;
  var bg = document.getElementById('theme_link_background_field').value;
  var color = document.getElementById('theme_link_color_field').value;
  var r = parseInt(document.getElementById('theme_link_rounded_field').value);
  var s = parseInt(document.getElementById('theme_link_shadow_field').value);
  var blur = parseInt(document.getElementById('theme_link_blur_field').value);
  var opac = parseInt(document.getElementById('theme_link_opacity_field').value);
  preview.style.backgroundColor = _hexToRgba(bg, opac);
  preview.style.borderRadius = r >= 24 ? '9999px' : r + 'px';
  if (s === 0) { preview.style.boxShadow = 'none'; }
  else {
    var y = (s * 0.4).toFixed(1);
    var opacity = (0.04 + s * 0.018).toFixed(3);
    preview.style.boxShadow = '0 ' + y + 'px ' + s + 'px rgba(0,0,0,' + opacity + ')';
  }
  var bdFilter = blur > 0 ? 'blur(' + blur + 'px)' : 'none';
  preview.style.backdropFilter = bdFilter;
  preview.style.webkitBackdropFilter = bdFilter;
  preview.querySelectorAll('span, svg').forEach(function(el) { el.style.color = color; });
  var bgDot = document.getElementById('link-bg-dot');
  var bgHex = document.getElementById('link-bg-hex');
  var textDot = document.getElementById('link-text-dot');
  var textHex = document.getElementById('link-text-hex');
  if (bgDot) bgDot.style.background = bg;
  if (bgHex) bgHex.textContent = bg;
  if (textDot) textDot.style.background = color;
  if (textHex) textHex.textContent = color;
  var rl = document.getElementById('rounded-val-label');
  if (rl) rl.textContent = r >= 24 ? '∞' : r + 'px';
  var sl = document.getElementById('shadow-val-label');
  if (sl) sl.textContent = s;
  var bll = document.getElementById('link-blur-label');
  if (bll) bll.textContent = blur + 'px';
  var oll = document.getElementById('link-opacity-label');
  if (oll) oll.textContent = opac + '%';
}

/* ── 7. Sticky Buttons ── */

function updateStickyPreview() {
  var bg = document.getElementById('sticky_btn_background_field').value;
  var color = document.getElementById('sticky_btn_color_field').value;
  var bgDot = document.getElementById('sticky-bg-dot');
  var bgHex = document.getElementById('sticky-bg-hex');
  var iconDot = document.getElementById('sticky-icon-dot');
  var iconHex = document.getElementById('sticky-icon-hex');
  if (bgDot) bgDot.style.background = bg;
  if (bgHex) bgHex.textContent = bg;
  if (iconDot) iconDot.style.background = color;
  if (iconHex) iconHex.textContent = color;
  updateStickyShape();
}
function updateStickyShape() {
  var r = parseInt(document.getElementById('sticky_btn_rounded_field').value);
  var s = parseInt(document.getElementById('sticky_btn_shadow_field').value);
  var blur = parseInt(document.getElementById('sticky_btn_blur_field').value);
  var opac = parseInt(document.getElementById('sticky_btn_opacity_field').value);
  var bdr = parseInt(document.getElementById('sticky_btn_border_field').value);
  var bg = document.getElementById('sticky_btn_background_field').value;
  var color = document.getElementById('sticky_btn_color_field').value;
  var rl = document.getElementById('sticky-rounded-label');
  var sl = document.getElementById('sticky-shadow-label');
  var bll = document.getElementById('sticky-blur-label');
  var oll = document.getElementById('sticky-opacity-label');
  var bdrl = document.getElementById('sticky-border-label');
  if (rl) rl.textContent = r + 'px';
  if (sl) sl.textContent = s + 'px';
  if (bll) bll.textContent = blur + 'px';
  if (oll) oll.textContent = opac + '%';
  if (bdrl) bdrl.textContent = bdr + 'px';
  var bgRgba = _hexToRgba(bg, opac);
  var bdFilter = blur > 0 ? 'blur(' + blur + 'px)' : 'none';
  ['sticky-preview-download', 'sticky-preview-share'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) {
      el.style.backgroundColor = bgRgba;
      el.style.borderRadius = r + 'px';
      el.style.boxShadow = '0 ' + s + 'px ' + (s*2) + 'px rgba(0,0,0,0.15)';
      el.style.backdropFilter = bdFilter;
      el.style.webkitBackdropFilter = bdFilter;
      el.style.border = bdr > 0 ? bdr + 'px solid ' + color : 'none';
    }
  });
}

/* ── 8. Background Type ── */

function switchBgType(type) {
  ['color', 'gradient', 'image', 'theme'].forEach(function(t) {
    var el = document.getElementById('bg-option-' + t);
    if (el) el.classList.toggle('hidden', t !== type);
  });
  document.querySelectorAll('[data-bg-type]').forEach(function(label) {
    var isActive = label.dataset.bgType === type;
    label.className = 'px-2.5 py-1 text-[11px] rounded-lg cursor-pointer transition-all border ' +
      (isActive ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-gray-200 hover:bg-gray-50 text-gray-600');
  });
}
function updateBgColorPreview() {
  var val = document.getElementById('bg_color_field').value;
  var dot = document.getElementById('bg-color-dot');
  var hex = document.getElementById('bg-color-hex');
  if (dot) dot.style.background = val;
  if (hex) hex.textContent = val;
}
function updateBgGradPreview() {
  var from = document.getElementById('bg_grad_from_field').value;
  var to = document.getElementById('bg_grad_to_field').value;
  var fromDot = document.getElementById('bg-grad-from-dot');
  var fromHex = document.getElementById('bg-grad-from-hex');
  var toDot = document.getElementById('bg-grad-to-dot');
  var toHex = document.getElementById('bg-grad-to-hex');
  if (fromDot) fromDot.style.background = from;
  if (fromHex) fromHex.textContent = from;
  if (toDot) toDot.style.background = to;
  if (toHex) toHex.textContent = to;
}

/* ── 9. Sticker ── */

var _stickerPreviewRatio = 140.0 / 375.0;

function _stickerHiddenField() { return document.getElementById('sticker_url_field'); }

function _stickerSubmit() {
  var f = document.getElementById('sticker_x_field');
  if (f && f.form) { f.form.requestSubmit(); return; }
  f = _stickerHiddenField();
  if (f && f.form) f.form.requestSubmit();
}

function setStickerLayer(behind) {
  var field = document.getElementById('sticker_behind_field');
  if (field) { field.value = behind; field.form.requestSubmit(); }
  var frontBtn = document.getElementById('sticker-layer-front');
  var behindBtn = document.getElementById('sticker-layer-behind');
  if (frontBtn) frontBtn.className = 'px-1.5 py-0.5 text-[8px] rounded transition-all border ' + (!behind ? 'border-indigo-400 bg-indigo-50 text-indigo-700' : 'border-gray-200 text-gray-400 hover:bg-gray-50');
  if (behindBtn) behindBtn.className = 'px-1.5 py-0.5 text-[8px] rounded transition-all border ' + (behind ? 'border-indigo-400 bg-indigo-50 text-indigo-700' : 'border-gray-200 text-gray-400 hover:bg-gray-50');
}

function switchStickerMode(mode) {
  var typeField = document.getElementById('sticker_type_field');
  typeField.value = mode;
  var imgSection = document.getElementById('sticker-image-section');
  var textSection = document.getElementById('sticker-text-section');
  var btnImg = document.getElementById('sticker-mode-image');
  var btnTxt = document.getElementById('sticker-mode-text');
  var activeClass = 'bg-indigo-500 text-white shadow-sm';
  var inactiveClass = 'text-gray-500 hover:bg-gray-50';

  if (mode === 'text') {
    imgSection.classList.add('hidden');
    textSection.classList.remove('hidden');
    btnTxt.className = 'px-3 py-1.5 text-xs font-medium rounded-md transition-all ' + activeClass;
    btnImg.className = 'px-3 py-1.5 text-xs font-medium rounded-md transition-all ' + inactiveClass;
    var img = document.getElementById('sticker-preview-img');
    var txt = document.getElementById('sticker-preview-text');
    if (img) img.classList.add('hidden');
    if (txt) { txt.classList.remove('hidden'); }
    updateStickerTextPreview();
  } else {
    textSection.classList.add('hidden');
    imgSection.classList.remove('hidden');
    btnImg.className = 'px-3 py-1.5 text-xs font-medium rounded-md transition-all ' + activeClass;
    btnTxt.className = 'px-3 py-1.5 text-xs font-medium rounded-md transition-all ' + inactiveClass;
    var img2 = document.getElementById('sticker-preview-img');
    var txt2 = document.getElementById('sticker-preview-text');
    if (txt2) txt2.classList.add('hidden');
    if (img2 && img2.src) img2.classList.remove('hidden');
  }
  _stickerSubmit();
}

function selectGroupSticker(url) {
  _stickerHiddenField().value = url;
  document.getElementById('sticker_type_field').value = 'image';
  // Clear any previously uploaded sticker_image so sticker_url takes precedence
  var removeField = document.getElementById('remove_sticker_image_field');
  if (removeField) removeField.value = '1';
  var img = document.getElementById('sticker-preview-img');
  var txt = document.getElementById('sticker-preview-text');
  var placeholder = document.getElementById('sticker-placeholder');
  var controls = document.getElementById('sticker-controls');
  if (img) { img.src = url; img.classList.remove('hidden'); img.style.opacity = '1'; }
  if (txt) txt.classList.add('hidden');
  if (placeholder) placeholder.classList.add('hidden');
  if (controls) controls.classList.remove('hidden');
  var opField = document.getElementById('sticker_opacity_field');
  if (opField) opField.value = 100;
  var opLabel = document.getElementById('sticker-opacity-label');
  if (opLabel) opLabel.textContent = '100%';
  // Update thumbnail border highlights
  var container = document.querySelector('#sticker-image-section');
  if (container) {
    container.querySelectorAll('[onclick^="selectGroupSticker"]').forEach(function(el) {
      var isSelected = el.getAttribute('onclick').indexOf(url) !== -1;
      el.className = el.className.replace(/border-indigo-500|border-gray-200|ring-1|ring-indigo-200/g, '').trim();
      if (isSelected) {
        el.classList.add('border-indigo-500', 'ring-1', 'ring-indigo-200');
      } else {
        el.classList.add('border-gray-200');
      }
    });
  }
  _initStickerDrag();
  _stickerSubmit();
}

function removeSticker() {
  _stickerHiddenField().value = '';
  document.getElementById('sticker_type_field').value = 'image';
  var removeField = document.getElementById('remove_sticker_image_field');
  if (removeField) removeField.value = '1';
  var img = document.getElementById('sticker-preview-img');
  var txt = document.getElementById('sticker-preview-text');
  var placeholder = document.getElementById('sticker-placeholder');
  var controls = document.getElementById('sticker-controls');
  if (img) img.classList.add('hidden');
  if (txt) txt.classList.add('hidden');
  if (placeholder) placeholder.classList.remove('hidden');
  if (controls) controls.classList.add('hidden');
  var textField = document.getElementById('sticker_text_field');
  if (textField) textField.value = '';
  _stickerSubmit();
}

function updateStickerPreview() {
  var x = parseInt(document.getElementById('sticker_x_field').value);
  var y = parseInt(document.getElementById('sticker_y_field').value);
  var scale = parseInt(document.getElementById('sticker_scale_field').value);
  var opacity = parseInt(document.getElementById('sticker_opacity_field').value);
  var rotation = parseInt(document.getElementById('sticker_rotation_field').value);
  var previewScale = scale * _stickerPreviewRatio;

  var isText = document.getElementById('sticker_type_field').value === 'text';
  var el = isText ? document.getElementById('sticker-preview-text') : document.getElementById('sticker-preview-img');

  if (el) {
    el.style.left = x + '%';
    el.style.top = y + '%';
    el.style.opacity = (opacity / 100).toFixed(2);
    if (isText) {
      el.style.fontSize = (previewScale * 0.25) + 'px';
      el.style.transform = 'translate(-50%, -50%) rotate(' + rotation + 'deg)';
    } else {
      el.style.width = previewScale + 'px';
      el.style.transform = 'translate(-50%, -50%) rotate(' + rotation + 'deg)';
    }
  }

  var xl = document.getElementById('sticker-x-label');
  var yl = document.getElementById('sticker-y-label');
  var sl = document.getElementById('sticker-scale-label');
  var ol = document.getElementById('sticker-opacity-label');
  var rl = document.getElementById('sticker-rotation-label');
  if (xl) xl.textContent = x + '%';
  if (yl) yl.textContent = y + '%';
  if (sl) sl.textContent = scale + 'px';
  if (ol) ol.textContent = opacity + '%';
  if (rl) rl.textContent = rotation + '°';
}

function updateStickerTextPreview() {
  var txt = document.getElementById('sticker-preview-text');
  var textField = document.getElementById('sticker_text_field');
  var fontField = document.getElementById('sticker_font_field');
  var colorField = document.getElementById('sticker_color_field');
  var controls = document.getElementById('sticker-controls');
  var placeholder = document.getElementById('sticker-placeholder');

  if (txt && textField) {
    txt.textContent = textField.value || '';
    if (fontField) txt.style.fontFamily = "'" + fontField.value + "', sans-serif";
    if (colorField) txt.style.color = colorField.value;

    if (textField.value) {
      txt.classList.remove('hidden');
      if (placeholder) placeholder.classList.add('hidden');
      if (controls) controls.classList.remove('hidden');
      _initStickerDragText();
    } else {
      txt.classList.add('hidden');
      if (placeholder) placeholder.classList.remove('hidden');
    }
  }
  updateStickerPreview();
}

function toggleStickerStyle(style) {
  var field = document.getElementById('sticker_' + style + '_field');
  var btn = document.getElementById('sticker-btn-' + style);
  var isOn = field.value === 'true';
  field.value = isOn ? 'false' : 'true';

  var activeClass = 'bg-indigo-500 text-white border-indigo-500';
  var inactiveClass = 'border-gray-300 text-gray-600 hover:bg-gray-50';

  var baseDecoration = {bold: 'font-bold', italic: 'italic', underline: 'underline', strikethrough: 'line-through'};
  if (isOn) {
    btn.className = 'w-9 h-9 rounded-md border flex items-center justify-center text-sm ' + baseDecoration[style] + ' transition-all ' + inactiveClass;
  } else {
    btn.className = 'w-9 h-9 rounded-md border flex items-center justify-center text-sm ' + baseDecoration[style] + ' transition-all ' + activeClass;
  }

  var txt = document.getElementById('sticker-preview-text');
  if (txt) {
    var bold = document.getElementById('sticker_bold_field').value === 'true';
    var italic = document.getElementById('sticker_italic_field').value === 'true';
    var underline = document.getElementById('sticker_underline_field').value === 'true';
    var strikethrough = document.getElementById('sticker_strikethrough_field').value === 'true';
    txt.style.fontWeight = bold ? 'bold' : 'normal';
    txt.style.fontStyle = italic ? 'italic' : 'normal';
    var decos = [];
    if (underline) decos.push('underline');
    if (strikethrough) decos.push('line-through');
    txt.style.textDecoration = decos.length ? decos.join(' ') : 'none';
  }
  _stickerSubmit();
}

/* ── Sticker Drag & Drop ── */

var _stickerDrag = { active: false, saveTimer: null };

function _getDraggableEl() {
  var isText = document.getElementById('sticker_type_field').value === 'text';
  return isText ? document.getElementById('sticker-preview-text') : document.getElementById('sticker-preview-img');
}

function _initStickerDrag() {
  var img = document.getElementById('sticker-preview-img');
  if (img && !img._dragInit) {
    img._dragInit = true;
    img.addEventListener('mousedown', _stickerDragStart);
    img.addEventListener('touchstart', _stickerDragStart, { passive: false });
  }
  _initStickerDragText();
}

function _initStickerDragText() {
  var txt = document.getElementById('sticker-preview-text');
  if (txt && !txt._dragInit) {
    txt._dragInit = true;
    txt.addEventListener('mousedown', _stickerDragStart);
    txt.addEventListener('touchstart', _stickerDragStart, { passive: false });
  }
}

function _stickerDragStart(e) {
  e.preventDefault();
  _stickerDrag.active = true;
  var el = _getDraggableEl();
  if (el) el.style.cursor = 'grabbing';
  var ch = document.getElementById('sticker-crosshair-h');
  var cv = document.getElementById('sticker-crosshair-v');
  if (ch) ch.classList.remove('hidden');
  if (cv) cv.classList.remove('hidden');

  if (e.type === 'mousedown') {
    document.addEventListener('mousemove', _stickerDragMove);
    document.addEventListener('mouseup', _stickerDragEnd);
  } else {
    document.addEventListener('touchmove', _stickerDragMove, { passive: false });
    document.addEventListener('touchend', _stickerDragEnd);
  }
}

function _stickerDragMove(e) {
  if (!_stickerDrag.active) return;
  e.preventDefault();
  var container = document.getElementById('sticker-preview-container');
  var el = _getDraggableEl();
  if (!container || !el) return;

  var rect = container.getBoundingClientRect();
  var clientX = e.touches ? e.touches[0].clientX : e.clientX;
  var clientY = e.touches ? e.touches[0].clientY : e.clientY;

  var xPct = Math.round(((clientX - rect.left) / rect.width) * 100);
  var yPct = Math.round(((clientY - rect.top) / rect.height) * 100);
  xPct = Math.max(0, Math.min(100, xPct));
  yPct = Math.max(0, Math.min(100, yPct));

  el.style.left = xPct + '%';
  el.style.top = yPct + '%';

  var ch = document.getElementById('sticker-crosshair-h');
  var cv = document.getElementById('sticker-crosshair-v');
  if (ch) ch.style.top = yPct + '%';
  if (cv) cv.style.left = xPct + '%';

  var xField = document.getElementById('sticker_x_field');
  var yField = document.getElementById('sticker_y_field');
  if (xField) xField.value = xPct;
  if (yField) yField.value = yPct;

  var xl = document.getElementById('sticker-x-label');
  var yl = document.getElementById('sticker-y-label');
  if (xl) xl.textContent = xPct + '%';
  if (yl) yl.textContent = yPct + '%';
}

function _stickerDragEnd(e) {
  if (!_stickerDrag.active) return;
  _stickerDrag.active = false;
  var el = _getDraggableEl();
  if (el) el.style.cursor = 'grab';
  var ch = document.getElementById('sticker-crosshair-h');
  var cv = document.getElementById('sticker-crosshair-v');
  if (ch) ch.classList.add('hidden');
  if (cv) cv.classList.add('hidden');

  document.removeEventListener('mousemove', _stickerDragMove);
  document.removeEventListener('mouseup', _stickerDragEnd);
  document.removeEventListener('touchmove', _stickerDragMove);
  document.removeEventListener('touchend', _stickerDragEnd);

  clearTimeout(_stickerDrag.saveTimer);
  _stickerDrag.saveTimer = setTimeout(function() { _stickerSubmit(); }, 300);
}

/* ── Initialization ── */

function _initThemeEditor() {
  // Panel: read initial color count from data attribute
  var panelContainer = document.querySelector('[data-panel-color-count]');
  if (panelContainer) {
    _panelColorCount = parseInt(panelContainer.dataset.panelColorCount) || 1;
    _paletteTarget['panel'] = _panelColorCount >= 2 ? 'theme_panel_gradient_from_field' : 'theme_panel_background_color_field';
  }

  // Panel: init texture overlay
  var texField = document.getElementById('panel_texture_field');
  if (texField && texField.value && texField.value !== 'none') {
    updatePanelTextureOverlay(texField.value);
  }
  updatePanelBorderRadius();

  // Sticker: read preview ratio from data attribute
  var stickerContainer = document.getElementById('sticker-preview-container');
  if (stickerContainer && stickerContainer.dataset.previewRatio) {
    _stickerPreviewRatio = parseFloat(stickerContainer.dataset.previewRatio);
  }

  // Init sticker drag
  _initStickerDrag();
}

/* ── Export all public functions to window ── */

var _exports = {
  _cpPickColor: _cpPickColor,
  _cpNativeChanged: _cpNativeChanged,
  _cpHexCommit: _cpHexCommit,
  updateImagesPreview: updateImagesPreview,
  panelClickPill: panelClickPill,
  panelSwapColors: panelSwapColors,
  panelAddColor: panelAddColor,
  panelRemoveColor: panelRemoveColor,
  panelColorChanged: panelColorChanged,
  setPanelGradientDir: setPanelGradientDir,
  setPanelTexture: setPanelTexture,
  updateTextureIntensity: updateTextureIntensity,
  updateTextureSize: updateTextureSize,
  updatePanelPreview: updatePanelPreview,
  updatePanelBorderRadius: updatePanelBorderRadius,
  updateNamePreview: updateNamePreview,
  toggleNameBold: toggleNameBold,
  toggleNameItalic: toggleNameItalic,
  textColorChanged: textColorChanged,
  updateContactPreview: updateContactPreview,
  updateBtnPreview: updateBtnPreview,
  updateStickyPreview: updateStickyPreview,
  updateStickyShape: updateStickyShape,
  switchBgType: switchBgType,
  updateBgColorPreview: updateBgColorPreview,
  updateBgGradPreview: updateBgGradPreview,
  switchStickerMode: switchStickerMode,
  selectGroupSticker: selectGroupSticker,
  removeSticker: removeSticker,
  updateStickerPreview: updateStickerPreview,
  updateStickerTextPreview: updateStickerTextPreview,
  toggleStickerStyle: toggleStickerStyle,
  setStickerLayer: setStickerLayer,
  showPanelAnchors: showPanelAnchors
};

Object.keys(_exports).forEach(function(name) {
  window[name] = _exports[name];
});

/* ── Bind initialization to page lifecycle ── */

document.addEventListener('DOMContentLoaded', _initThemeEditor);
document.addEventListener('turbo:render', _initThemeEditor);
document.addEventListener('turbo:frame-render', _initThemeEditor);
if (document.readyState !== 'loading') _initThemeEditor();
